import { safeJsonParse } from "common/utilities/safeJsonParse";
import type { SessionModel } from "context/session/sessionTypes";

type SessionStorage = { si_session_state: SessionModel };

export const readFromSessionStorage = <T extends keyof SessionStorage>(key: T) => {
  const value = sessionStorage.getItem(key);
  if (value === null) return undefined;
  const result = safeJsonParse(value);
  if (result === undefined) return undefined;
  return result.value as SessionStorage[T];
};

export const writeToSessionStorage = <T extends keyof SessionStorage>(key: T, value: SessionStorage[T]) =>
  sessionStorage.setItem(key, JSON.stringify(value));
